import { useSyncExternalStore } from 'react';

/** Whether the Get set up dock is on screen (bottom-right), so the job dock can sit above it. */
let shown = false;
const listeners = new Set<() => void>();

export const setSetupDockShown = (value: boolean) => {
  if (shown === value) return;
  shown = value;
  listeners.forEach(l => l());
};

export const useSetupDockShown = () => useSyncExternalStore(
  (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
  () => shown,
);
